import { c as _c } from "react/compiler-runtime";
import { publishEvent } from '@udemy-v2/event-tracking';
import { Icon } from '@udemy-v2/icons';
import { IconButton } from '@udemy-v2/react-core-components';
import { Dropdown } from '@udemy-v2/react-menu-components';
import classNames from 'classnames';
import React, { useState, MouseEvent } from 'react';
import { ReportAbuse } from '../../report-abuse/report-abuse.react-component';
import { ReviewReportEvent } from '../../../events/events';
import styles from './review-report.module.scss';
import { useI18n } from '@udemy-v2/i18n';
export interface ReviewReportProps {
  reviewId: number;
  frontendTrackingId?: string;
  reviewableObjectId: number;
  reviewableObjectType: string;
  isFeaturedReview?: boolean;
  shouldUseDeattachedDropdown?: boolean;
  shouldClosePopper?: boolean;
  placement?: 'bottom-end' | 'top-end';
  reviewAuthorName: string;
}
export const ReviewReport = t0 => {
  const $ = _c(26);
  const {
    reviewId,
    frontendTrackingId,
    reviewableObjectId,
    reviewableObjectType,
    isFeaturedReview: t1,
    shouldUseDeattachedDropdown: t2,
    shouldClosePopper: t3,
    placement: t4,
    reviewAuthorName
  } = t0;
  const isFeaturedReview = t1 === undefined ? false : t1;
  const shouldUseDeattachedDropdown = t2 === undefined ? false : t2;
  const shouldClosePopper = t3 === undefined ? false : t3;
  const placement = t4 === undefined ? "bottom-end" : t4;
  const [isOpen, setIsOpen] = useState(false);
  const {
    gettext,
    interpolate
  } = useI18n();
  const prevShouldClosePopperRef = React.useRef(shouldClosePopper);
  let t5;
  let t6;
  if ($[0] !== isOpen || $[1] !== shouldClosePopper) {
    t5 = () => {
      if (shouldClosePopper && !prevShouldClosePopperRef.current && isOpen) {
        setIsOpen(false);
      }
      prevShouldClosePopperRef.current = shouldClosePopper;
    };
    t6 = [shouldClosePopper, isOpen];
    $[0] = isOpen;
    $[1] = shouldClosePopper;
    $[2] = t5;
    $[3] = t6;
  } else {
    t5 = $[2];
    t6 = $[3];
  }
  React.useEffect(t5, t6);
  let t7;
  if ($[4] !== frontendTrackingId || $[5] !== isFeaturedReview || $[6] !== reviewId || $[7] !== reviewableObjectId || $[8] !== reviewableObjectType) {
    t7 = event => {
      event?.stopPropagation();
      if (frontendTrackingId) {
        publishEvent(new ReviewReportEvent({
          courseTrackingId: frontendTrackingId,
          reviewId,
          isFeatured: isFeaturedReview,
          reviewableObjectId,
          reviewableObjectType
        }));
      }
    };
    $[4] = frontendTrackingId;
    $[5] = isFeaturedReview;
    $[6] = reviewId;
    $[7] = reviewableObjectId;
    $[8] = reviewableObjectType;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleReportClick = t7;
  let t8;
  if ($[10] !== gettext || $[11] !== interpolate || $[12] !== reviewAuthorName) {
    t8 = props => <IconButton udStyle="ghost" {...props}><Icon glyph="more" label={interpolate(gettext("Additional actions for review by %(name)s"), {
        name: reviewAuthorName
      }, true)} size="small" color="neutral" /></IconButton>;
    $[10] = gettext;
    $[11] = interpolate;
    $[12] = reviewAuthorName;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = classNames("ud-heading-sm", styles["report-abuse-label"]);
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== gettext) {
    t10 = gettext("Report");
    $[15] = gettext;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== handleReportClick || $[18] !== reviewId || $[19] !== t10) {
    t11 = <Dropdown.Menu><Dropdown.MenuItem componentClass="div" className={styles["menu-item"]}><ReportAbuse className={t9} objectId={reviewId} objectType="coursereview" onClick={handleReportClick} size="medium" text={t10} /></Dropdown.MenuItem></Dropdown.Menu>;
    $[17] = handleReportClick;
    $[18] = reviewId;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== placement || $[22] !== shouldUseDeattachedDropdown || $[23] !== t11 || $[24] !== t8) {
    t12 = <Dropdown useDrawer={false} onToggle={setIsOpen} menuWidth="auto" detachFromTarget={shouldUseDeattachedDropdown} placement={placement} renderTrigger={t8}>{t11}</Dropdown>;
    $[21] = placement;
    $[22] = shouldUseDeattachedDropdown;
    $[23] = t11;
    $[24] = t8;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
};